module.exports = __webpack_public_path__ + "static/media/choose_right.93992d5b.jpg";